import React from "react"
import { Button } from "reactstrap"

const TablePaginationFooter = ({
  totalCount,
  currentPage,
  pageSize,
  itemLabel,
  isLoading = false,
  isFetching = false,
  onChangePage,
}) => {
  const totalPages = totalCount > 0 ? Math.ceil(totalCount / pageSize) : 1
  const startItem = totalCount === 0 ? 0 : (currentPage - 1) * pageSize + 1
  const endItem = Math.min(currentPage * pageSize, totalCount)

  return (
    <div className="d-flex justify-content-between align-items-center mt-2">
      <div className="text-muted" style={{ fontSize: "0.9rem" }}>
        Mostrando {startItem}-{endItem} de {totalCount} {itemLabel}
      </div>
      <div className="d-flex align-items-center" style={{ gap: "8px" }}>
        <Button
          color="secondary"
          outline
          size="sm"
          disabled={currentPage <= 1 || isLoading || isFetching}
          onClick={() => onChangePage(currentPage - 1)}
        >
          Anterior
        </Button>
        <span style={{ minWidth: "92px", textAlign: "center" }}>
          Página {currentPage} / {totalPages}
        </span>
        <Button
          color="secondary"
          outline
          size="sm"
          disabled={currentPage >= totalPages || isLoading || isFetching}
          onClick={() => onChangePage(currentPage + 1)}
        >
          Siguiente
        </Button>
      </div>
    </div>
  )
}

export default TablePaginationFooter